<template>
    <div class="footer">
        <div class="footer-top">
            <div v-if="footerTopItems" class="footer-container">
                <div class="img-container">
                    <div class="footer-logo-container">
                        <img src="@/assets/logos/footer-logo.png" alt="Footer Logo" class="footer-logo">
                    </div>
                    <img
                        src="@/assets/icons/footer-arrow-up.png"
                        alt="Scroll to Top"
                        class="scroll-top"
                        @click="goToTop"
                    >
                </div>
                <div class="footer-top-menu">
                    <div class="menu">
                        <a
                            v-for="(item, i) in footerTopItems.slice()"
                            :key="i"
                            class="menu-item"
                            :href="item.url"
                        >
                            {{ item.title }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-center">
            <div class="footer-container">
                <div class="footer-bottom-menu">
                    <div class="menu">
                        <a
                            v-for="(item, i) in footerBottomItems"
                            :key="i"
                            class="bottom-menu-item"
                            :href="item.url"
                        >
                            {{ item.title }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-bottom">
            <div class="copyright">
                Copyright © 2021 karelia.gr, All rights reserved
            </div>
            <div class="site-info">
                {{ $t('footer.siteInfo') }}
            </div>
        </div>
    </div>
</template>

<script>
    import menuService from '@/services/menu-service'
    export default {
        name: 'Footer',
        data() {
            return {
                menu: {}
            }
        },
        computed: {
            footerTopItems() {
                const langUpperCase = this.$root.$i18n.locale.toUpperCase()
                return this.menu && this.menu[langUpperCase] && this.menu[langUpperCase]['footer-top']
            },
            footerBottomItems() {
                const langUpperCase = this.$root.$i18n.locale.toUpperCase()
                return this.menu && this.menu[langUpperCase] && this.menu[langUpperCase]['footer-bottom']
            }
        },
        created() {
            this.fetchMenu()
        },
        methods: {
            fetchMenu() {
                menuService.fetchMenu()
                    .then(data => {
                        this.menu = data
                    })
            },
            goToTop() {
                document.body.scrollTop = 0
                document.documentElement.scrollTop = 0
            }
        }
    }
</script>

<style scoped>
.footer {
    width: 100%;
    max-width: 1920px;
    margin: 0 auto;
    font-family: 'Roboto', sans-serif;
}

.footer-container {
    width: 95%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
}

.footer-top {
    width: 100%;
    background: linear-gradient(to right, rgb(0, 114, 167) 0%, rgb(66, 157, 215) 40%, rgb(66, 157, 215) 60%, rgb(66, 157, 215) 100%);
}

.img-container {
    width: 100%;
    margin: 0 auto;
    border-bottom: 1px solid #fff;
    display: flex;
    justify-content: center;
    padding: 15px 0;
    position: relative;
}

.footer-logo-container {
    width: 102px;
}

.footer-logo-container img{
    width: 100%;
    height: auto;
}

.scroll-top {
    width: 30px;
    position: absolute;
    right: 0;
    top: 25%;
    cursor: pointer;
}

.footer-top-menu,
.footer-bottom-menu {
    display: block;
    margin: 0 auto;
    padding: 15px;
}

.menu {
    display: flex;
    flex-direction: column;
    position: relative;
    text-align: left;
}

.menu-item-header {
    font-size: 0.72rem !important;
    font-weight: 500 !important;
    text-align: center;
}

.menu-item,
.bottom-menu-item {
    color: #fff;
    text-decoration: none;
    font-size: 0.72rem;
    font-weight: 400;
    margin-bottom: 10px;
    position: relative;
}

.bottom-menu-item {
    margin-bottom: 5px;
    font-size: 0.65rem;

}

.footer-center {
    width: 100%;
    background: linear-gradient(to right, rgb(0, 106, 159) 0%, rgb(60, 146, 204) 40%, rgb(60, 146, 204) 60%, rgb(60, 146, 204) 100%);
}

.footer-bottom {
    color: #6c6c6c;
    font-size: 0.54rem;
    padding: 15px 0;
    width: 95%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
}

.menu-item:first-child::before {
    background-image: url(../assets/icons/links-icon.png);
    background-size: 24px 16px;
    display: inline-block;
    width: 24px;
    height: 16px;
    content:"";
    margin-left: -32px;
    margin-right: 4px;
}

.menu-item:last-child::before {
    background-image: url(../assets/icons/links-icon2.png);
    background-size: 31px 16px;
    display: inline-block;
    width: 31px;
    height: 16px;
    content:"";
    margin-left: -38px;
    margin-right: 4px;
}


.copyright{
    margin-bottom: 5px;
}

@media screen and (min-width: 480px) {
    .footer-logo-container {
        width: 150px;
    }

    .img-container {
        padding: 20px 0;
    }

    .scroll-top {
        width: 35px;
        top: 35%;
    }

    .menu-item{
        font-size: 0.90rem;
    }

    .bottom-menu-item {
        font-size: 0.76rem;
    }

    .footer-bottom {
        font-size: 0.63rem;
    }
}

@media screen and (min-width: 768px) {
    .footer-container {
        width: 85%;
    }

    .img-container {
        padding: 25px 0;
    }

    .footer-logo-container {
        width: 170px;
    }

    .scroll-top {
        width: 40px;
        top: 35%;
    }

    .menu {
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        max-width: 580px;
    }

    .footer-bottom {
        width: 80%;
    }

    .menu-item{
        font-size: 0.95rem;
    }
    .menu-item + .menu-item {
        margin-left: 1rem;
    }



    .bottom-menu-item {
        padding: 0 0.5rem;
        font-size: 0.81rem;
    }

    .menu-icon2 {
        left: 390px;
    }

    .bottom-menu-item + .bottom-menu-item {
        border-left: 1px solid #fff;
    }
}

@media screen and (min-width: 992px) {
    .footer-container {
        width: 80%;
    }

    .img-container {
        padding: 30px 0;
    }

    .footer-logo-container {
        width: 203px;
    }

    .scroll-top {
        width: 45px;
        top: 35%;
    }

    .menu {
        max-width: none;
    }

    .menu-item{
        font-size: 1.05rem;
    }

    .menu-item:last-child {
        margin-left: 52px;
    }

    .footer-bottom {
        flex-direction: row;
        width: 90%;
        padding: 22px 0;
        font-size: 0.74rem;
    }

    .copyright {
        width: 300px;
        margin-right: 1rem;
    }

    .site-info {
        width: 100%;
    }
}

@media screen and (min-width: 1200px) {
    .copyright {
        width: 340px;
        margin-right: 2rem;
    }
}
</style>